import Expositores from "./Expositores";
import Home from "./Home";
import PostersInfo from "./PostersInfo";
import Programa from "./Programa";

const Jornada3 = () => {
    return (
        <div>
            <Home is2026 showPresentacion={false} />

                  <hr className="wp-block-separator" />
            <PostersInfo />

            <Programa is2026 />

        </div>
    )
 }

 export default Jornada3;
